import { render, staticRenderFns } from "./tabInternationalCardBaseUICustomLayout.vue?vue&type=template&id=ce7145c2&"
import script from "./tabInternationalCardBaseUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabInternationalCardBaseUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce7145c2')) {
      api.createRecord('ce7145c2', component.options)
    } else {
      api.reload('ce7145c2', component.options)
    }
    module.hot.accept("./tabInternationalCardBaseUICustomLayout.vue?vue&type=template&id=ce7145c2&", function () {
      api.rerender('ce7145c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/booking/tabs/tabInternationalCardBaseUICustomLayout.vue"
export default component.exports